/* =========================================================================
   HERMES — Organizador de Gorras · v1b · vanilla JS (no deps)
   CTA pattern regla 5.R: un solo botón real con hook classes (#hm-gor-main-cta),
   hero/sticky son anchors <a href="#hm-gor-cta-final"> con scroll nativo.
   Animaciones gated: los estados iniciales ocultos solo aplican bajo .js-anim
   (regla 1 / PASO 54) — sin JS la landing queda 100% visible.
   ========================================================================= */
(function () {
  'use strict';
  var ROOT = document.querySelector('.hm-gor');
  if (!ROOT) return;

  /* -----------------------------------------------------------------------
     0) ANTI-SPY + DESKTOP BLOCK
     ----------------------------------------------------------------------- */
  var caught = document.getElementById('hm-gor-caught');
  var antiSpyOn = ROOT.classList.contains('hm-gor--anti-spy');
  var desktopBlockOn = ROOT.classList.contains('hm-gor--desktop-block');

  function showCaught(mode) {
    if (!caught) return;
    caught.classList.add('is-active');
    caught.setAttribute('data-hm-gor-mode-active', mode);
    caught.querySelectorAll('.hm-gor-caught__mode').forEach(function (m) {
      m.classList.toggle('is-shown', m.getAttribute('data-hm-gor-mode') === mode);
    });
  }

  function isDesktopLike() {
    try {
      var wide = window.matchMedia('(min-width: 1024px)').matches;
      var hoverFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var noTouch = !('ontouchstart' in window) && navigator.maxTouchPoints === 0;
      return wide || hoverFine || noTouch;
    } catch (e) { return false; }
  }

  if (desktopBlockOn && isDesktopLike()) {
    showCaught('desktop');
  }

  if (antiSpyOn) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
      if (!isDesktopLike()) showCaught('spy');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].indexOf(e.key.toUpperCase()) > -1)) {
        e.preventDefault();
        showCaught('spy');
      }
    });
    var devtoolsThreshold = 200;
    setInterval(function () {
      var wDelta = window.outerWidth - window.innerWidth;
      var hDelta = window.outerHeight - window.innerHeight;
      if ((wDelta > devtoolsThreshold || hDelta > devtoolsThreshold) && !isDesktopLike()) {
        showCaught('spy');
      }
    }, 1200);
  }

  /* If blocked, short-circuit (no animations, no Releasit setup) */
  if (desktopBlockOn && isDesktopLike()) return;

  /* -----------------------------------------------------------------------
     1) Gate de animaciones — solo si el JS corre se ocultan los estados
        iniciales (.js-anim). Regla 1 / PASO 54.
     ----------------------------------------------------------------------- */
  ROOT.classList.add('js-anim');

  /* -----------------------------------------------------------------------
     2) HERO — headline slide-in + stickers slap-in
     ----------------------------------------------------------------------- */
  requestAnimationFrame(function () {
    document.querySelectorAll('[data-hl]').forEach(function (el) {
      var delay = parseFloat(el.getAttribute('data-hl-delay') || '0');
      setTimeout(function () { el.classList.add('is-in'); }, 220 + delay * 1000);
    });
    document.querySelectorAll('[data-sticker]').forEach(function (el) {
      var delay = parseFloat(el.getAttribute('data-sticker-delay') || '0');
      setTimeout(function () { el.classList.add('is-in'); }, 700 + delay * 1000);
    });
  });

  /* -----------------------------------------------------------------------
     3) IntersectionObserver generic reveal (colcards, steps, fill-word)
     ----------------------------------------------------------------------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.22 });
  document.querySelectorAll('.hm-gor-colcard, .hm-gor-step, [data-fillword]').forEach(function (el) { io.observe(el); });

  /* -----------------------------------------------------------------------
     4) STATS — count-up Teko (animación nueva de esta landing)
     ----------------------------------------------------------------------- */
  (function countUp() {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cio.unobserve(entry.target);
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-countup'), 10) || 0;
        var start = null;
        var dur = 900;
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(eased * target);
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { cio.observe(el); });
  })();

  /* -----------------------------------------------------------------------
     5) ANTES/DESPUÉS — slider drag interactivo (demostrativo TikTok)
     ----------------------------------------------------------------------- */
  (function baSlider() {
    var stage = document.getElementById('hm-gor-ba-stage');
    var before = document.getElementById('hm-gor-ba-before');
    var handle = document.getElementById('hm-gor-ba-handle');
    if (!stage || !before || !handle) return;

    var pct = 50;
    function render() {
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', String(Math.round(pct)));
    }
    function setFromClientX(x) {
      var r = stage.getBoundingClientRect();
      pct = Math.max(4, Math.min(96, ((x - r.left) / r.width) * 100));
      render();
    }
    var dragging = false;
    stage.addEventListener('pointerdown', function (e) {
      dragging = true;
      stage.setPointerCapture && stage.setPointerCapture(e.pointerId);
      setFromClientX(e.clientX);
    });
    stage.addEventListener('pointermove', function (e) {
      if (dragging) setFromClientX(e.clientX);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      stage.addEventListener(ev, function () { dragging = false; });
    });
    handle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { pct = Math.max(4, pct - 5); render(); }
      if (e.key === 'ArrowRight') { pct = Math.min(96, pct + 5); render(); }
    });
    /* nudge inicial para invitar al drag */
    var nudged = false;
    var nio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !nudged) {
          nudged = true;
          nio.unobserve(stage);
          var t0 = null;
          function nudge(ts) {
            if (!t0) t0 = ts;
            var p = Math.min((ts - t0) / 1400, 1);
            pct = 50 + Math.sin(p * Math.PI * 2) * 12 * (1 - p);
            render();
            if (p < 1 && !dragging) requestAnimationFrame(nudge);
          }
          requestAnimationFrame(nudge);
        }
      });
    }, { threshold: 0.6 });
    nio.observe(stage);
    render();
  })();

  /* -----------------------------------------------------------------------
     6) Sticky CTA — dual IntersectionObserver (hero out / final in)
     ----------------------------------------------------------------------- */
  (function stickyCta() {
    var sticky = document.querySelector('[data-hm-gor-sticky]');
    var heroCta = document.querySelector('.hm-gor-hero__cta');
    var finalCta = document.getElementById('hm-gor-cta-final');
    if (!sticky) return;
    var heroVisible = true;
    var finalVisible = false;

    function sync() {
      sticky.classList.toggle('is-visible', !heroVisible && !finalVisible);
    }
    if (heroCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { heroVisible = e.isIntersecting; sync(); });
      }, { threshold: 0 }).observe(heroCta);
    }
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { finalVisible = e.isIntersecting; sync(); });
      }, { rootMargin: '0px 0px -40% 0px' }).observe(finalCta);
    }
  })();

  /* -----------------------------------------------------------------------
     7) Kill Releasit floating button dinámicamente (regla 5.B)
     ----------------------------------------------------------------------- */
  (function killFloating() {
    var tries = 0;
    var maxTries = 48; /* 24s @ 500ms */
    var iv = setInterval(function () {
      tries++;
      document.querySelectorAll('._rsi-buy-now-button-floating, [class*="_rsi-buy-now"][class*="floating"], [class*="_rsi-floating"], .rsi_floating, #floatingBuyNowButton').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
      if (tries >= maxTries) clearInterval(iv);
    }, 500);
  })();

  /* -----------------------------------------------------------------------
     8) Releasit submit skin — vence inline styles del merchant (regla 5.C)
     ----------------------------------------------------------------------- */
  (function releasitSubmitSkin() {
    function skin(el) {
      if (!el) return;
      el.style.setProperty('background', 'linear-gradient(135deg, #FF5A1F, #E04A12)', 'important');
      el.style.setProperty('color', '#ffffff', 'important');
      el.style.setProperty('border-radius', '999px', 'important');
      el.style.setProperty('border', 'none', 'important');
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('min-height', '54px', 'important');
      el.style.setProperty('width', '100%', 'important');
    }
    function sweep() {
      document.querySelectorAll('[class*="_rsi"][class*="submit"], [class*="_rsi-cod-form"] button[type="submit"], [class*="_rsi-modal"] button').forEach(skin);
    }
    sweep();
    var mo = new MutationObserver(sweep);
    mo.observe(document.body, { childList: true, subtree: true });
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      sweep();
      if (tries >= 80) clearInterval(iv); /* ~40s @ 500ms */
    }, 500);
    document.addEventListener('click', function () { setTimeout(sweep, 60); });
  })();

  console.info('[HERMES gor] chassis ready');
})();
